import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { DocumentsTab } from "./DocumentsTab";

interface JobDocumentsSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  jobId: string;
  documents: any[];
  onDocumentsUpdate: () => void;
}

export const JobDocumentsSheet = ({
  open,
  onOpenChange,
  jobId,
  documents,
  onDocumentsUpdate,
}: JobDocumentsSheetProps) => {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full sm:max-w-2xl overflow-y-auto">
        <SheetHeader>
          <SheetTitle>Documents</SheetTitle>
        </SheetHeader>
        <div className="mt-6">
          <DocumentsTab
            jobId={jobId}
            documents={documents}
            onDocumentsUpdate={onDocumentsUpdate}
          />
        </div>
      </SheetContent>
    </Sheet>
  );
};
